/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'building/shipyard_4_orbital': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M19 8l-3 6-3-6z"/><path pid="1" d="M12 8l4 8.572L20 8h3l-7 14L9 8z"/><path pid="2" d="M8 8l8 16 8-16h2L15.985 28 6 8zM22 4h2v2h-2zM11 4h2v2h-2zM19 4h2v2h-2zM8 4h2v2H8zM8 21h1v2H8zM23 21h1v2h-1z"/><path pid="3" d="M21 21l2.5-5 .5-1v6zM11 21l-2.5-5-.5-1v6zM8 6h16v1H8zM25 14h1v-3l-1 2zM7 14H6v-3l1 2zM23 24h1v1h-1zM23 27h1v1h-1zM8 27h1v1H8zM8 24h1v1H8zM25 15h1v1h-1zM6 15h1v1H6zM27 8h1v6h-1zM4 8h1v6H4z"/><path pid="4" d="M15 32H0V17h1v14h14zM32 32H17v-1h14V17h1zM32 15h-1V1H17V0h15zM1 15H0V0h15v1H1z"/>'
  }
})
